module.exports = {"340405001":"新庄孜街道","340405002":"土坝孜街道","340405003":"毕家岗街道","340405100":"八公山镇","340405121":"山王镇","340405400":"妙山林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340405.json
// module id = 1176
// module chunks = 0